// Copyright (c) 2017 Deere & Company

import t from 'tcomb';

const UserPrivacy = t.struct({
    cmInvoiceRequestNotAllowed: t.Boolean,
    cmShowTechId: t.Boolean,
    customerPrivate: t.Boolean,
    laborStatsNotAllowed: t.Boolean,
    registrationFormNotAllowed: t.Boolean,
    registrationNotAllowed: t.Boolean,
    showWaitingForDealerInvoice: t.Boolean
}, {
    name: 'UserPrivacy',
    strict: true
});

export const getDefaultState = () => new UserPrivacy({
    cmInvoiceRequestNotAllowed: false,
    cmShowTechId: false,
    customerPrivate: false,
    laborStatsNotAllowed: false,
    registrationFormNotAllowed: false,
    registrationNotAllowed: false,
    showWaitingForDealerInvoice: false
});

export default UserPrivacy;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/user-privacy.js